<div class="cads-labeled-amount-bit" role="group">
  <span [class]="labelClass()">{{ config().label }}</span>
  <span [class]="amountClass()">
    ${{ amountFigures() }}
  </span>
</div>
